import React from 'react';

import { generateRandomBlockId } from '@wp-block-builder/package';

import { TContainerBlock } from '../../../../../blocks/Container';
import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';
import { TBlock } from '../../../../../blocks/types';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style?: TBlock['style']): TContainerBlock => ({
  id: generateRandomBlockId(),
  type: 'Container',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'normal',
    padding: '16px 24px 16px 24px',
    textAlign: 'left',
    ...style,
  },
  props: {
    blocks: [],
  },
  sectionProps: {},
});

export default defineBlockButton<TContainerBlock>({
  label: 'Container',
  icon: <BlockTypeIcon type="Container" />,
  defaultBlock: getDefaultProps,
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
